import React from 'react'
import Button from '@material-ui/core/Button'
import { formatAmount } from '../../lib/formatAmountHandler'
import StructureRow from './StructureRow'
import { koniecWaznosciLicencji } from '../../lib/consts'
import WariantLicencjiAwatar from './WariantLicencjiAwatar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function WariantLicencji({
  img,
  label,
  description,
  price,
  structures,
  canSelect,
  onSelect,
}) {
  return (
    <div className="wariantMain">
      <div className="wariant">
        <div className="wariantIdent">
          <WariantLicencjiAwatar wersja={label} />
          <div>
            <div className="high-headline-5">{label}</div>
            <div className="price">
              {price && (
                <>
                  <div className="medium-headline-5">
                    {formatAmount(price)} zł netto
                  </div>
                </>
              )}
              {img && (
                <FontAwesomeIcon icon={img} className="priceReplacementIcon" />
              )}
            </div>
          </div>
        </div>
        {canSelect ? (
          <Button
            className="infoButton"
            variant="contained"
            color="primary"
            onClick={() => onSelect(label, price)}
          >
            WYBIERZ
          </Button>
        ) : (
          <span className="primary-overline contact">
            SKONTAKTUJ SIĘ Z NAMI <br />
            BY DOWIEDZIEĆ SIĘ WIĘCEJ
          </span>
        )}
        <div className="disabled-body-2 wariantDesc">{description}</div>
        <div className="structureList">
          {structures.map(structure => {
            return (
              <StructureRow
                key={structure.symbol}
                symbol={structure.symbol}
                label={structure.name}
              />
            )
          })}
        </div>
      </div>
      <div className="medium-emphasis-caption">
        Licencja ważna do {koniecWaznosciLicencji} roku.
      </div>
    </div>
  )
}
